import * as tempusDominus from '@eonasdan/tempus-dominus'
import * as faPlugin from '@eonasdan/tempus-dominus/dist/plugins/fa-five'

// Use font awesome icons in the date time picker
tempusDominus.extend(faPlugin.load)

// Custom plugin to override the input parsing and formatting in the date time picker
tempusDominus.extend((_, { Dates }, { DateTime }) => {
  // Called when the datepicker is parsing the input field value
  Dates.prototype.setFromInput = function (value, _index) {
    const date = this.optionsStore.options.meta.parseInput(value)

    if (date == null) {
      // Input has been cleared
      this.setValue(null)
    } else if (date.isValid) {
      const tdDate = DateTime.convert(
        date.toJSDate(),
        this.optionsStore.options.localization.locale,
      )
      this.setValue(tdDate)
    } else {
      // Invalid date, reset input to previous value
      this.setValue(this.lastPicked)
    }
  }

  // Called when the datepicker is setting the input field
  Dates.prototype.formatInput = function (date) {
    return this.optionsStore.options.meta.formatInput(date)
  }
})

export const {
  TempusDominus: DateTimePicker,
  Namespace: { events: DateTimePickerEvents },
} = tempusDominus
